const errorMapping = {
    NO_COMPANY_FOUND: "NO_COMPANY_FOUND",
    TOO_MANY_REQUESTS: "TOO_MANY_REQUESTS",
    COMPANY_NOT_ACCEPTABLE: "COMPANY_NOT_ACCEPTABLE",
    INVALID_PROCESSING_STATUS: "INVALID_PROCESSING_STATUS",
    COMPANY_BANKRUPT_OR_SUSPENDED: "COMPANY_BANKRUPT_OR_SUSPENDED",
    BANNED_OR_NO_REQUIRED_SBI_CODE_FOUND: "BANNED_OR_NO_REQUIRED_SBI_CODE_FOUND"
};

export class CocValidation {
    constructor(errorCode, data) {
        this.errorCode = errorCode;
        this.data = data
    }

    hasError() {
        return !!this.errorCode;
    }

    static success(validation) {
        if (!validation.errorCode) {
            return new CocValidation(null, validation.data);
        }

        if (validation.errorCode === errorMapping.NO_COMPANY_FOUND) {
            return this.noCompanyFound();
        }

        return this.companyNotAcceptable();
    }

    static noCompanyFound() {
        return new CocValidation(errorMapping.NO_COMPANY_FOUND, null);
    }

    static tooManyRequests() {
        return new CocValidation(errorMapping.TOO_MANY_REQUESTS, null);
    }

    static companyNotAcceptable() {
        return new CocValidation(errorMapping.COMPANY_NOT_ACCEPTABLE, null);
    }
}
